import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CurrentTenantId, ExternalTenantId } from "src/app/core/constants/headerNames";
import { TenantSynchronizationService } from "src/app/core/services/tenant-synchronization.service";
@Injectable()
export class UserInitialisationInterceptor implements HttpInterceptor {
  constructor(private tenantSynchronizationService: TenantSynchronizationService) {

  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentTenantData = this.tenantSynchronizationService.getCurrentTenantData;

    let modifiedReq = request.clone();

    if (currentTenantData?.id && currentTenantData?.externalTenantId) {
      modifiedReq = modifiedReq.clone({
        headers: modifiedReq.headers.append(CurrentTenantId, currentTenantData.id.toString())
          .append(ExternalTenantId, currentTenantData.externalTenantId)
      });
    }
    return next.handle(modifiedReq)
  }
}
